export enum VisibilityPolicy {
  PUBLIC = 'PUBLIC',
  SEMI_PRIVATE = 'SEMI_PRIVATE',
  INTERNAL = 'INTERNAL'
}
